import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';
import { getDragStartEvent, getDragOverEvent, isDraggableConnectedToDroppable, getDragEndEvent, getDragCancelEvent } from './utils.js';

var useDndEvents = function useDndEvents(props) {
  var droppableInfoPerDroppableIdRef = props.droppableInfoPerDroppableIdRef,
    getId = props.getId,
    itemsPerDroppableId = props.itemsPerDroppableId,
    itemsPerDroppableIdOnDragStartRef = props.itemsPerDroppableIdOnDragStartRef,
    onDragCancel = props.onDragCancel,
    onDragEnd = props.onDragEnd,
    onDragOver = props.onDragOver,
    onDragStart = props.onDragStart,
    setActiveDragRender = props.setActiveDragRender,
    setItemsPerDroppableId = props.setItemsPerDroppableId;
  var copyDragInfo = React.useRef(null);
  var handleDragStart = React.useCallback(function (event) {
    itemsPerDroppableIdOnDragStartRef.current = itemsPerDroppableId;
    setActiveDragRender(event.active.data.current.dragOverlay);
    var dragStartEvent = getDragStartEvent(event.active, itemsPerDroppableIdOnDragStartRef.current, getId);
    if (event.active.data.current.droppableMode === "copy") {
      copyDragInfo.current = {
        droppableId: dragStartEvent.sourceDroppableId,
        index: dragStartEvent.sourceIndex
      };
    }
    if (onDragStart) {
      onDragStart(dragStartEvent);
    }
  }, [getId, itemsPerDroppableId, itemsPerDroppableIdOnDragStartRef, onDragStart, setActiveDragRender]);
  var handleDragOver = React.useCallback(function (event) {
    var _objectSpread2;
    var dragOverEvent = getDragOverEvent(event.active, event.over, itemsPerDroppableId, getId);
    if (onDragOver) {
      onDragOver(dragOverEvent);
    }
    if (!event.over) {
      return;
    }
    var sourceDroppableId = dragOverEvent.sourceDroppableId;
    var targetDroppableId = dragOverEvent.targetDroppableId;
    if (!sourceDroppableId || !targetDroppableId || sourceDroppableId === targetDroppableId || !isDraggableConnectedToDroppable(droppableInfoPerDroppableIdRef.current[targetDroppableId].connectId, event.active.data.current.connectedTo)) {
      return;
    }
    var targetItems = itemsPerDroppableId[targetDroppableId];
    var sourceIndex = dragOverEvent.sourceIndex || 0;
    var targetIndex = dragOverEvent.targetIndex || 0;
    var newIndex;
    if (copyDragInfo.current && copyDragInfo.current.droppableId === targetDroppableId) {
      newIndex = copyDragInfo.current.index;
    } else {
      var isBelowLastItem = targetIndex === targetItems.length - 1;
      var modifier = isBelowLastItem ? 1 : 0;
      newIndex = targetIndex >= 0 ? targetIndex + modifier : targetItems.length + 1;
    }
    var sourceItemsClone = _toConsumableArray(itemsPerDroppableId[sourceDroppableId]);
    var itemToMove = sourceItemsClone.splice(sourceIndex, 1)[0];
    var targetItemsClone = _toConsumableArray(itemsPerDroppableId[targetDroppableId]);
    targetItemsClone.splice(newIndex, 0, itemToMove);
    setItemsPerDroppableId(_objectSpread(_objectSpread({}, itemsPerDroppableId), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, sourceDroppableId, sourceItemsClone), _defineProperty(_objectSpread2, targetDroppableId, targetItemsClone), _objectSpread2)));
  }, [droppableInfoPerDroppableIdRef, getId, itemsPerDroppableId, onDragOver, setItemsPerDroppableId]);
  var handleDragEnd = React.useCallback(function (event) {
    setActiveDragRender(null);
    copyDragInfo.current = null;
    if (!onDragEnd) {
      setItemsPerDroppableId(itemsPerDroppableIdOnDragStartRef.current);
      return;
    }
    var dragEndEvent = getDragEndEvent(event.active, event.over, itemsPerDroppableIdOnDragStartRef.current, getId);
    onDragEnd(dragEndEvent);
  }, [getId, itemsPerDroppableIdOnDragStartRef, onDragEnd, setActiveDragRender, setItemsPerDroppableId]);
  var handleDragCancel = React.useCallback(function (event) {
    setItemsPerDroppableId(itemsPerDroppableIdOnDragStartRef.current);
    setActiveDragRender(null);
    if (onDragCancel) {
      var dragCancelEvent = getDragCancelEvent(event.active, event.over, itemsPerDroppableIdOnDragStartRef.current, getId);
      onDragCancel(dragCancelEvent);
    }
  }, [getId, itemsPerDroppableIdOnDragStartRef, onDragCancel, setActiveDragRender, setItemsPerDroppableId]);
  return {
    handleDragCancel: handleDragCancel,
    handleDragStart: handleDragStart,
    handleDragOver: handleDragOver,
    handleDragEnd: handleDragEnd
  };
};

export { useDndEvents };
